export default {
  "content": "<path d=\"M4.15 3.25c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0-1a2 2 0 10-.001 3.999A2 2 0 004.15 2.25zm8 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0-1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM2.5 14.4a.47.47 0 01-.35-.15c-.2-.2-.2-.51 0-.71L13.54 2.15c.2-.2.51-.2.71 0 .2.2.2.51 0 .71L2.85 14.25c-.1.1-.23.15-.35.15z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};